<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/avatars/man.png"
        class="img-avatar"
        alt="user"/>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item @click="profile"><i class="fa fa-user" /> Profilo</b-dropdown-item>
      <b-dropdown-item @click="changePwd"><i class="fa fa-lock" /> Cambio password</b-dropdown-item>
      <b-dropdown-item @click="notImplemented"><i class="fa fa-wrench" /> Impostazioni</b-dropdown-item>
      <b-dropdown-item @click="recharge"><i class="fa fa-usd" /> Ricarica</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {}
  },
  methods: {
    profile() {
      this.$router.push('/profile');
    },
    changePwd() {
      this.$router.push('/changepwd');
    },
    recharge() {
      window.open('https://goo.gl/9vp0k4', '_blank');
    },
    logout() {
      this.$store.dispatch('logout').then(() => this.$router.push('/login'));
    },
    notImplemented() {
      alert('Non ancora implementato');
    }
  }
}
</script>
